// libraries
import { CustomText, SpacerColumn } from '@components/atoms';
import { CustomModal } from '@components/molecules';
import React from 'react';
import styled from 'styled-components/native';
import { Image } from 'react-native';

// misc
import safari1 from '@assets/images/safari-1.jpeg';
import safari2 from '@assets/images/safari-2.jpeg';

// types
export type SafariInstallInstructionModalProps = {
  isVisible: boolean;
  onClose(): void;
};

export const SafariInstallInstructionModal: React.FC<SafariInstallInstructionModalProps> = ({
  isVisible,
  onClose,
}) => {
  // variables

  // functions

  // renders
  return (
    <CustomModal isVisible={isVisible} onClose={onClose}>
      <Content>
        <CustomText font="bodyBold" textAlign="center" size={16}>
          Follow bellow steps to install app on your mobile
        </CustomText>
        <SpacerColumn size={4} />
        <CustomText size={14}>
          Step 1: Click on share icon available on your bottom navigation bar.
        </CustomText>
        <SpacerColumn size={2} />
        <Image source={safari1} style={{ height: 30, aspectRatio: 1 }} />
        <SpacerColumn size={4} />
        <CustomText size={14}>
          Step 2: A menu will appear, Now Scroll down and click on Add To Home Screen button. Done.
        </CustomText>
        <SpacerColumn size={2} />
        <Image source={safari2} style={{ height: 130, aspectRatio: 1 }} />
      </Content>
    </CustomModal>
  );
};

const Content = styled.View(({ theme: { layout } }) => ({
  marginTop: layout.padding_x2,
  width: '80%',
  alignSelf: 'center',
}));
